import React from 'react';
import { Segment, Form, Button, Message, Icon } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';

import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class Options extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            documentReasons: [],
            documentReason: '',
            printOptions: [
                {
                    value: true,
                    key: 'withLogo',
                    text: 'sa logom'
                },
                {
                    value: false,
                    key: 'withoutLogo',
                    text: 'bez loga'
                }
            ],
            documentVersions: [
                {
                    value: '-24/25',
                    key: '-24/25',
                    text: 'do akademske 24/25'
                },
                {
                    value: '24/25-25/26',
                    key: '24/25-25/26',
                    text: 'od akademske 24/25 do akademske 25/26'
                },
                {
                    value: '25/26-',
                    key: '25/26-',
                    text: 'od akademske 25/26'
                }
            ],
            alphabetList: [
                {
                    value: 'lat',
                    key: 'lat',
                    text: 'Latinica'
                },
                {
                    value: 'cyr',
                    key: 'cyr',
                    text: 'Ćirilica'
                }
            ],

            // fallback kad nema props
            localSelectedValues: {
                issueDate: new Date(),
                documentType: '',
                documentReason: '',
                language: '',
                withLogo: true,
                documentVersion: '25/26-',
                alphabet: 'lat'
            },
            localAvailableValuesList: {
                documentTypes: [],
                documentReasons: [],
                languages: []
            }
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getReasons = this.getReasons.bind(this);
        this.updateValue = this.updateValue.bind(this);
        this.isControlledMode = this.isControlledMode.bind(this);
    }

    componentDidMount() {
        const hasExternalAvailableValues =
            this.props.printOptionsFiltersAvailableValuesList &&
            Object.keys(this.props.printOptionsFiltersAvailableValuesList).length > 0;

        if (!hasExternalAvailableValues && this.props.initialAvailableValuesList) {
            this.setState({
                localAvailableValuesList: {
                    documentTypes: this.props.initialAvailableValuesList.documentTypes || [],
                    documentReasons: this.props.initialAvailableValuesList.documentReasons || [],
                    languages: this.props.initialAvailableValuesList.languages || []
                }
            });
        }

        if (this.props.initialSelectedValues) {
            this.setState(prevState => ({
                localSelectedValues: {
                    ...prevState.localSelectedValues,
                    ...this.props.initialSelectedValues
                }
            }));
        }
    }

    isControlledMode() {
        return !!(
            this.props.printOptionsFiltersSelectedValues &&
            this.props.onPrintOptionsFilterChange
        );
    }

    updateValue(name, value) {
        if (this.isControlledMode()) {
            this.props.onPrintOptionsFilterChange(name, value);
        } else {
            this.setState(prevState => ({
                localSelectedValues: {
                    ...prevState.localSelectedValues,
                    [name]: value
                }
            }));
        }
    }

    getReasons(id) {
        axios.get('/document-reasons/get-reasons/' + id)
            .then(res => {
                if (res.data.length === 0) {
                    this.setState({ documentReasons: [], documentReason: '' });
                    return;
                }

                const documentReasons = res.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: el.name
                }));

                const studentServiceFixedReason = this.props.studentService
                    ? documentReasons.find(r => r.name === 'Probno štampanja')
                    : null;

                const firstReasonValue = studentServiceFixedReason
                    ? studentServiceFixedReason.value
                    : documentReasons[0].value;

                this.setState({
                    documentReasons,
                    documentReason: firstReasonValue
                });

                this.updateValue('documentReason', firstReasonValue);
            })
            .catch(err => {
                console.log('Failed to fetch reasons');
            });
    }

    handleInputChange(event, { name, value }) {
        this.updateValue(name, value);

        if (name === 'documentType') {
            this.getReasons(value);
        }
    }

    handleChange(event) {
        event.preventDefault();
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        this.updateValue(name, value);
    }

    handleDateChange(name, date) {
        this.updateValue(name, date);
    }

    render() {
        const selectedValues = this.isControlledMode()
            ? this.props.printOptionsFiltersSelectedValues
            : this.state.localSelectedValues;

        const availableValuesList =
            this.props.printOptionsFiltersAvailableValuesList &&
            Object.keys(this.props.printOptionsFiltersAvailableValuesList).length > 0
                ? this.props.printOptionsFiltersAvailableValuesList
                : this.state.localAvailableValuesList;

        const {
            issueDate,
            documentType,
            documentReason,
            language,
            withLogo,
            documentVersion,
            alphabet
        } = selectedValues;

        const {
            documentTypes = [],
            documentReasons = [],
            languages = []
        } = availableValuesList;

        const {
            printOptions,
            documentVersions,
            alphabetList
        } = this.state;

        const formContent = (
            <div>
                {/* {!this.props.oneStudent && ( */}
                {/*     <h3>Opcije za štampanje</h3> */}
                {/* )} */}

                <Form>
                    <Form.Field>
                        <label>Vrsta dokumenta</label>
                        <Form.Select
                            value={documentType}
                            onChange={this.handleInputChange}
                            name="documentType"
                            options={documentTypes}
                            search
                            fluid
                        />
                    </Form.Field>
                </Form>

                <br />

                <Form>
                    <Form.Field>
                        <label>Izgled dokumenta</label>
                        <Form.Select
                            value={withLogo}
                            onChange={this.handleInputChange}
                            name="withLogo"
                            options={printOptions}
                            search
                            fluid
                        />
                    </Form.Field>
                </Form>

                <br />

                { !this.props.studentService && <Form>
                    <Form.Field>
                        <label>Verzija dokumenta</label>
                        <Form.Select
                            value={documentVersion}
                            onChange={this.handleInputChange}
                            name="documentVersion"
                            options={documentVersions}
                            search
                            fluid
                        />
                    </Form.Field>
                </Form>}

                { !this.props.studentService && <br />}

                { !this.props.studentService && <Form>
                    <Form.Field>
                        <label>Razlog štampanja</label>
                        <Form.Select
                            value={this.state.documentReason ? this.state.documentReason : documentReason}
                            onChange={this.handleInputChange}
                            name="documentReason"
                            options={this.state.documentReasons.length ? this.state.documentReasons : documentReasons}
                            search
                            fluid
                        />
                    </Form.Field>
                </Form> }

                { !this.props.studentService && <br /> }
                <Form>
                    <Form.Field>
                        <label>Jezik</label>
                        <Form.Select
                            value={language}
                            onChange={this.handleInputChange}
                            name="language"
                            options={languages}
                            search
                            fluid
                        />
                    </Form.Field>
                </Form>

                { this.props.admin && <br />}

                { this.props.admin && <Form>
                    <Form.Field>
                        <label>Pismo</label>
                        <Form.Select
                            value={alphabet}
                            onChange={this.handleInputChange}
                            name="alphabet"
                            options={alphabetList}
                            search
                            fluid
                        />
                    </Form.Field>
                </Form>}

                <br />

                { !this.props.studentService && <Form.Field>
                    <label>Datum izdavanja</label>
                    <DateTimePicker
                        format="D. M. YYYY."
                        defaultValue={new Date()}
                        time={false}
                        onChange={this.handleDateChange.bind(null, 'issueDate')}
                        value={issueDate}
                    />
                </Form.Field>}

                { !this.props.studentService && <br />}

                {!this.props.oneStudent ? (
                    <div>
                        <Button
                            color="blue"
                            basic
                            floated="left"
                            onClick={() => this.props.changeWizardStep && this.props.changeWizardStep('prev')}
                        >
                            Nazad
                        </Button>

                        <Button
                            color="blue"
                            floated="right"
                            onClick={() => this.props.changeWizardStep && this.props.changeWizardStep('next')}
                        >
                            Prikaži studente
                        </Button>
                    </div>
                ) :
                    <Button
                        floated="right"
                        icon
                        labelPosition="left"
                        color="blue"
                        loading={this.props.directPrintLoading}
                        disabled={this.props.directPrintLoading}
                        onClick={() => {
                            if (this.props.onDirectPrint) {
                                this.props.onDirectPrint();
                            }
                        }}
                    >
                        <Icon className="print" />
                        Štampanje
                    </Button>}


            </div>
        );

        if (this.props.oneStudent) {
            return (<div>
                {this.props.studentService && <Message>
                    Odaberite željene opcije ispod i preuzmite primjer diplome ili dodatka diplomi kako biste provjerili podatke prije finalnog štampanja.
                    Dokumenti koje preuzimate služe isključivo za provjeru podataka te se ne mogu koristiti kao validni dokumenti.
                </Message>}
                {formContent}</div>);
        }

        return (
            <div>
                <Segment.Group raised>
                    <Segment>
                        <h3>Opcije za štampanje</h3>
                    </Segment>
                    <Segment clearing>
                        {formContent}
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/Options.js